import type { StorePromotionalAd, StoreWebsiteEditorStateV3 } from '@dukanti/shared';

/**
 * Epic #228 P7: whether publishing this template takes the store off the old
 * store page, the only page that shows ads. True while the store is still
 * legacy and the template is a fixed design; the frozen original keeps the
 * ads slot, so publishing it changes nothing for ads.
 */
export function publishHidesLegacyAds(
  state: Pick<StoreWebsiteEditorStateV3, 'mode' | 'template'> | undefined,
): boolean {
  return (
    state?.mode === 'legacy' && state.template !== null && state.template.kind !== 'legacy-frozen'
  );
}

/** At least one ad shoppers see today. Inactive ads are not shown anywhere. */
export function hasActiveAd(ads: readonly Pick<StorePromotionalAd, 'is_active'>[]): boolean {
  return ads.some((ad) => ad.is_active);
}
